/* Quatre étapes locales ; suggestions issues des métachamps réels du catalogue. */
(() => {
  function init(root) {
    if (root.dataset.sensorielPret) return;
    root.dataset.sensorielPret = 'true';
    const scenes = [...root.querySelectorAll('[data-s-etape]')];
    const notes = [...root.querySelectorAll('input[type="checkbox"]')];
    const range = root.querySelector('[data-s-intensite]');
    const compteur = root.querySelector('[data-s-compteur]');
    const progression = root.querySelector('[data-s-progres]');
    const descriptions = {
      Relaxation: 'Le temps d’une pause, le plaisir d’une infusion.',
      Power: 'Des notes franches, un caractère affirmé.',
      Flourish: 'La curiosité des arômes, le plaisir de découvrir.'
    };
    const titres = ['Votre univers', 'Vos notes', 'Votre intensité', 'La théine'];
    let step = 0;
    let univers = '';
    let theine = '';
    let pending = null;
    let reached = 0;
    let portraitReady = false;
    const portraitKey = 'chanoyu.sensoriel';
    const draftKey = 'chanoyu.sensoriel.brouillon';
    const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const selection = () => notes.filter(note => note.checked).map(note => note.value);
    const dose = () => Number(range.value) < 34 ? 'délicate' : Number(range.value) < 67 ? 'équilibrée' : 'corsée';

    const current = () => ({ version: 1, univers, notes: selection(), intensite: Number(range.value), theine });
    function saveDraft() {
      try { sessionStorage.setItem(draftKey, JSON.stringify({ ...current(), step, reached, portraitReady })); } catch (_) { /* Stockage facultatif. */ }
    }
    function notesLabel() {
      const button = scenes[1].querySelector('[data-s-suivant]');
      button.textContent = portraitReady ? 'Actualiser mon portrait' : selection().length ? 'Continuer avec ces notes' : 'Me laisser surprendre';
    }
    function show(index, focus = true) {
      clearTimeout(pending);
      pending = null;
      root.dataset.sDirection = index < step ? 'retour' : 'suite';
      step = Math.max(0, Math.min(4, index));
      reached = Math.max(reached, step);
      const values = [univers, selection().join(', ') || 'Au fil des envies', dose(), theine];
      const landmarks = root.querySelector('[data-s-reperes]');
      if (landmarks) landmarks.hidden = reached === 0;
      root.querySelectorAll('[data-s-ajuster]').forEach(button => {
        const i = Number(button.dataset.sAjuster);
        button.hidden = i >= reached || i === step;
        button.querySelector('[data-s-valeur]').textContent = values[i];
        button.setAttribute('aria-label', `${['Univers', 'Notes', 'Intensité', 'Théine'][i]} : ${values[i]}. Modifier`);
      });
      root.querySelectorAll('[data-s-suivant]').forEach(button => { button.textContent = portraitReady ? 'Actualiser mon portrait' : 'Continuer'; });
      notesLabel();
      scenes.forEach((scene, i) => { scene.hidden = i !== step; });
      compteur.textContent = step === 4 ? 'Votre portrait de goût' : `0${step + 1} / 04 · ${titres[step]}`;
      progression.style.transform = `scaleX(${Math.min((step + 1) / 4, 1)})`;
      if (step < 4 && univers) saveDraft();
      if (!focus) return; // Retrouver un parcours ne déplace jamais la page au chargement.
      const title = scenes[step].querySelector('.sensoriel__titre');
      title.focus({ preventScroll: true });
      const rect = title.getBoundingClientRect();
      if (rect.top < 120 || rect.bottom > window.innerHeight) {
        title.scrollIntoView({ block: 'start', behavior: reduced() ? 'instant' : 'smooth' });
      }
    }

    function advance(action) {
      if (pending !== null) return;
      pending = setTimeout(() => { pending = null; action(); }, reduced() ? 0 : 350);
    }

    root.querySelectorAll('[data-s-univers]').forEach(button => {
      const describe = () => {
        root.style.setProperty('--s-ambiance', `var(--s-${button.dataset.sUnivers.toLowerCase()})`);
        root.querySelector('[data-s-univers-texte]').textContent = descriptions[button.dataset.sUnivers];
      };
      button.addEventListener('pointerenter', describe);
      button.addEventListener('focus', describe);
      button.addEventListener('click', () => {
        if (step !== 0 || pending !== null) return;
        univers = button.dataset.sUnivers;
        root.querySelectorAll('[data-s-univers]').forEach(item => item.classList.toggle('est-choisi', item === button));
        describe();
        advance(() => portraitReady ? finish() : show(1));
      });
    });
    notes.forEach(note => note.addEventListener('change', () => {
      const status = root.querySelector('[data-s-notes-etat]');
      if (selection().length > 3) {
        note.checked = false;
        status.textContent = 'Trois notes maximum. Décochez une note pour en choisir une autre.';
      } else {
        status.textContent = `${selection().length} / 3 notes choisies`;
      }
      notesLabel();
      saveDraft();
    }));
    function updateDose() {
      root.querySelector('[data-s-dose]').textContent = dose();
      range.setAttribute('aria-valuetext', `${dose()}, ${range.value} sur 100`);
      const liquid = root.querySelector('[data-s-liqueur]');
      if (liquid) liquid.style.opacity = String(.08 + Number(range.value) / 100 * .72);
    }
    range.addEventListener('input', () => { updateDose(); saveDraft(); });
    root.querySelectorAll('[data-s-intensite-choix]').forEach(button => button.addEventListener('click', () => {
      if (step !== 2 || pending !== null) return;
      range.value = button.dataset.sIntensiteChoix;
      updateDose();
      advance(() => portraitReady ? finish() : show(3));
    }));
    range.addEventListener('change', () => {
      const liquid = root.querySelector('[data-s-liqueur]');
      if (!liquid) return;
      liquid.classList.add('est-onde');
    });
    root.querySelector('[data-s-liqueur]')?.addEventListener('animationend', event => event.currentTarget.classList.remove('est-onde'));
    root.querySelectorAll('[data-s-suivant]').forEach(button => button.addEventListener('click', () => {
      if (pending !== null) return;
      advance(() => portraitReady ? finish() : show(step + 1));
    }));
    root.querySelectorAll('[data-s-retour]').forEach(button => button.addEventListener('click', () => show(step - 1)));
    root.querySelectorAll('[data-s-theine]').forEach(button => button.addEventListener('click', () => {
      if (step !== 3 || pending !== null) return;
      theine = button.dataset.sTheine;
      root.querySelectorAll('[data-s-theine]').forEach(item => item.classList.toggle('est-choisi', item === button));
      advance(finish);
    }));
    function renderSuggestions() {
      const target = root.querySelector('[data-s-suggestions]');
      const status = root.querySelector('[data-s-selection-etat]');
      const catalogue = root.querySelector('[data-s-catalogue]');
      if (!target || !status || !catalogue) return;
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      // Seuls les descripteurs explicites font foi. Une composition ne présume pas du goût.
      const aromes = {
        Florale: /\b(?:floral[e]?|fleuri[e]?)\b/,
        Fruitée: /\bfruite[e]?\b/,
        Végétale: /\b(?:vegetal[e]?|herbace[e]?)\b/,
        Épicée: /\bepice[e]?\b/,
        Boisée: /\bboise[e]?\b/,
        Gourmande: /\bgourmand[e]?\b/
      };
      const bucket = value => value < 34 ? 0 : value < 67 ? 1 : 2;
      const chosen = selection();
      const produits = [...catalogue.content.querySelectorAll('[data-s-produit]')];
      const matches = produits.flatMap(product => {
        const data = product.dataset;
        const intensity = Number(data.intensite);
        const caffeine = normalize(data.theine);
        if (!data.intensite || !Number.isFinite(intensity) || intensity < 0 || intensity > 100 ||
            normalize(data.univers) !== normalize(univers) || bucket(intensity) !== bucket(Number(range.value))) return [];
        // Une valeur absente ou inconnue n'est jamais interprétée comme « sans théine ».
        if (theine === 'Sans théine' && caffeine !== 'sans theine') return [];
        if (theine === 'Avec théine' && !['faible', 'moyenne', 'elevee'].includes(caffeine)) return [];
        const notes = chosen.filter(note => aromes[note]?.test(normalize(data.triade)));
        if (chosen.length && !notes.length) return [];
        return [{ product, notes, distance: Math.abs(intensity - Number(range.value)) }];
      }).sort((a, b) => b.notes.length - a.notes.length || a.distance - b.distance).slice(0, 3);
      target.replaceChildren();
      matches.forEach(({ product, notes }) => {
        const card = product.cloneNode(true);
        card.querySelector('[data-s-raison]').textContent = [univers, `Intensité ${dose()}`, ...notes,
          theine === 'Peu importe' ? product.dataset.theine : theine].filter(Boolean).join(' · ');
        target.append(card);
      });
      status.textContent = matches.length
        ? 'À explorer selon votre univers, votre intensité et votre choix de théine' + (chosen.length ? ', avec au moins une de vos notes. ' : '. ') + 'Les repères indiqués viennent des fiches des thés.'
        : 'Aucun thé disponible avec des données renseignées ne réunit ces choix. Ajustez vos repères ou explorez la carte.';
    }
    function renderPortrait() {
        renderSuggestions();
        const chosen = selection();
        const titles = { délicate: 'Tout en délicatesse.', équilibrée: 'Le goût de l’équilibre.', corsée: 'Du caractère dans la tasse.' };
        root.querySelector('[data-s-portrait]').textContent = titles[dose()];
        const accord = root.querySelector('[data-s-accord]');
        if (accord) accord.textContent = chosen.length ? `Vos notes : ${chosen.join(', ').toLowerCase()}.` : 'Des arômes à découvrir, au fil de vos envies.';
        root.querySelector('[data-s-resume]').textContent = `Univers ${univers}. ${theine === 'Peu importe' ? 'Avec ou sans théine, selon votre envie.' : `${theine}.`}`;
    }
    function finish() {
        renderPortrait();
        root.querySelector('[data-s-memoire]')?.setAttribute('hidden', '');
        // Clé distincte : l'ancien score de familles n'est pas une correspondance catalogue.
        let saved = false;
        try { localStorage.setItem(portraitKey, JSON.stringify(current())); saved = true; } catch (_) { /* Le parcours reste utilisable sans stockage. */ }
        const recording = root.querySelector('[data-s-enregistrement]');
        if (recording) recording.textContent = saved ? 'Votre portrait est enregistré sur cet appareil. Recommencer efface ces choix.' : 'Votre navigateur ne permet pas de garder ce portrait. Il reste disponible sur cette page.';
        try { sessionStorage.removeItem(draftKey); } catch (_) { /* Stockage facultatif. */ }
        portraitReady = true;
        show(4);
    }
    root.querySelectorAll('[data-s-ajuster]').forEach(button => button.addEventListener('click', () => {
      const index = Number(button.dataset.sAjuster);
      if (index < reached) show(index);
    }));
    root.querySelector('[data-s-modifier]')?.addEventListener('click', () => {
      const first = root.querySelector('[data-s-ajuster]:not([hidden])');
      if (!first) return;
      first.focus({ preventScroll: true });
      root.querySelector('[data-s-reperes]').scrollIntoView({ block: 'start', behavior: reduced() ? 'instant' : 'smooth' });
    });
    root.querySelectorAll('[data-s-refaire]').forEach(button => button.addEventListener('click', () => {
      notes.forEach(note => { note.checked = false; });
      range.value = '50';
      univers = ''; theine = '';
      reached = 0; portraitReady = false;
      root.querySelectorAll('.est-choisi').forEach(item => item.classList.remove('est-choisi'));
      root.querySelector('[data-s-notes-etat]').textContent = '0 / 3 notes choisies';
      root.querySelector('[data-s-univers-texte]').textContent = 'Un élan, une pause, un instant pour soi.';
      root.querySelector('[data-s-memoire]')?.setAttribute('hidden', '');
      root.style.removeProperty('--s-ambiance');
      try { localStorage.removeItem(portraitKey); } catch (_) { /* Stockage facultatif. */ }
      try { sessionStorage.removeItem(draftKey); } catch (_) { /* Stockage facultatif. */ }
      updateDose(); show(0);
    }));
    function readSaved(storage, key, draft = false) {
      try {
        const value = JSON.parse(storage.getItem(key));
        const knownNotes = notes.map(note => note.value);
        if (!value || value.version !== 1 || typeof value.univers !== 'string' || !Object.hasOwn(descriptions, value.univers) ||
          !Array.isArray(value.notes) || value.notes.length > 3 || new Set(value.notes).size !== value.notes.length ||
          value.notes.some(note => !knownNotes.includes(note)) ||
          !Number.isInteger(value.intensite) || value.intensite < 0 || value.intensite > 100 ||
          !['', 'Peu importe', 'Avec théine', 'Sans théine'].includes(value.theine)) return null;
        if (draft) {
          if (!Number.isInteger(value.step) || value.step < 0 || value.step > 3 ||
            !Number.isInteger(value.reached) || value.reached < Math.max(1, value.step) || value.reached > 4 ||
            typeof value.portraitReady !== 'boolean' || (value.portraitReady && !value.theine)) return null;
        } else if (!value.theine) return null;
        return value;
      } catch (_) { return null; }
    }
    // Même appareil : portrait terminé persistant, progression limitée à la session.
    let draft = null; let saved = null;
    try { draft = readSaved(sessionStorage, draftKey, true); } catch (_) { /* Accès lui-même interdit. */ }
    try { saved = readSaved(localStorage, portraitKey); } catch (_) { /* Accès lui-même interdit. */ }
    const restored = draft || saved;
    if (restored) {
      univers = restored.univers; theine = restored.theine;
      range.value = String(restored.intensite);
      notes.forEach(note => { note.checked = restored.notes.includes(note.value); });
      root.querySelector('[data-s-notes-etat]').textContent = `${selection().length} / 3 notes choisies`;
      root.querySelectorAll('[data-s-univers]').forEach(button => button.classList.toggle('est-choisi', button.dataset.sUnivers === univers));
      root.querySelectorAll('[data-s-theine]').forEach(button => button.classList.toggle('est-choisi', button.dataset.sTheine === theine));
      root.querySelector('[data-s-univers-texte]').textContent = descriptions[univers];
      root.style.setProperty('--s-ambiance', `var(--s-${univers.toLowerCase()})`);
      portraitReady = draft ? draft.portraitReady : true;
      reached = draft ? draft.reached : 4;
      if (portraitReady) renderPortrait();
      const notice = root.querySelector('[data-s-memoire]');
      if (notice) {
        notice.hidden = false;
        root.querySelector('[data-s-memoire-texte]').textContent = draft ? 'Votre parcours reprend ici, avec vos choix.' : 'Votre portrait vous attend, avec vos derniers choix.';
      }
      const recording = root.querySelector('[data-s-enregistrement]');
      if (recording && !draft) recording.textContent = 'Portrait retrouvé sur cet appareil. Vous pouvez l’ajuster ou recommencer.';
      show(draft ? draft.step : 4, false);
    }
    updateDose();
    root.classList.add('est-pret');
  }
  function boot(scope) {
    scope.querySelectorAll('[data-sensoriel]').forEach(init);
    scope.querySelectorAll('[data-parcours-acces]').forEach(link => {
    if (link.dataset.parcoursPret) return;
    link.dataset.parcoursPret = 'true';
    link.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const target = document.querySelector('[data-sensoriel] [data-s-etape]:not([hidden]) .sensoriel__titre');
      if (!target) return;
      event.preventDefault();
      target.focus({ preventScroll: true });
      target.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    });
    });
  }
  boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
